import type { AdnConfig } from '../types';

const configAb: AdnConfig<'ab'> = {
  live_studio: {
    member: 9943,
    invCodeTemplate: 'se-aftonbladet-${device}-studio_${format}',
    afpTemplate: 'se-aftonbladet-tv-${device}-afp_${format}',
    formats: {
      preroll: true,
      bumper: true,
    },
    keywords: {
      pageType: 'front',
      publisherName: 'aftonbladet',
      publisherGroup: 'schibsted',
    },
  },
  ab: {
    member: 9943,
    invCodeTemplate: 'se-aftonbladet-tv-${device}-${section}_${format}',
    appInvCodeTemplate: 'se-aftonbladet-aph-article-${format}_${section}',
    afpTemplate: 'se-aftonbladet-tv-${device}-afp_${format}',
    knownSections: ['nyheter', 'sportbladet', 'nojesbladet', 'studio'],
    omitUnknownSection: true,
    defaultSection: 'ovrigaavdelningar',
    formats: {
      preroll: true,
      bumper: true,
      pause: true,
      midroll: true,
    },
    keywords: {
      pageType: 'article',
      publisherName: 'aftonbladet',
      publisherGroup: 'schibsted',
    },
    glimr: {
      enabled: true,
      keywordPrefix: 'kw_se-generic',
      country: 'se',
      clientId: 'OYGH3SXYFAQR78LVPNQD',
    },
    autoplayMuted: true,
  },
  abtv: {
    member: 9943,
    invCodeTemplate: 'se-aftonbladet-${device}-${section}-${format}',
    afpTemplate: 'se-aftonbladet-tv-${device}-afp_${format}',
    formats: {
      preroll: true,
      bumper: true,
      pause: true,
      midroll: true,
    },
    keywords: {
      pageType: 'article',
      publisherName: 'aftonbladet',
      publisherGroup: 'schibsted',
    },
    glimr: {
      enabled: true,
      keywordPrefix: 'kw_se-generic',
      country: 'se',
      schibstedAdChoicesEnabled: true,
      clientId: 'OYGH3SXYFAQR78LVPNQD',
    },
  },
  malservice: {
    member: 9943,
    invCodeTemplate: 'se-aftonbladet-tv-${device}-sportbladet_${format}',
    afpTemplate: 'se-aftonbladet-tv-${device}-afp_${format}',
    formats: {
      preroll: true,
      bumper: true,
      pause: true,
      midroll: true,
    },
    keywords: {
      pageType: 'article',
      publisherName: 'aftonbladet',
      publisherGroup: 'schibsted',
    },
  },
};

const configSvd: AdnConfig<'svd'> = {
  svd: {
    member: 9943,
    invCodeTemplate: 'se-svd-tv-${device}-${format}',
    afpTemplate: 'se-svd-tv-${device}-afp-${format}',
    formats: {
      preroll: true,
    },
    keywords: {
      pageType: 'article',
      publisherName: 'svd',
      publisherGroup: 'schibsted',
    },
  },
};

export { configAb, configSvd };
